import { ScrollView } from "../ScrollView.js";
import { IScrollViewScale } from "./IScrollViewScale.js";

export class ScrollViewScaleOriginal implements IScrollViewScale {
    public getScale(view: ScrollView): number {
        return 1;
    }
}